import { createSlice } from "@reduxjs/toolkit";
import { generateStateSingle } from "../../generators/generateState";
import {
  createData,
  createWithFile,
  deleteData,
  editData,
  fetchData,
  fetchEditData,
} from "../../generators/generateThunks";

const SLICE_NAME = "users";

export const fetchUsers = fetchData.generateThunk(SLICE_NAME, SLICE_NAME);
export const fetchUser = fetchEditData.generateThunk(SLICE_NAME, SLICE_NAME);
export const createUser = createData.generateThunk(
  SLICE_NAME,
  "users/register"
);
export const deleteUser = deleteData.generateThunk(SLICE_NAME, SLICE_NAME);
export const editUser = editData.generateThunk(SLICE_NAME, SLICE_NAME);

const userSlice = createSlice({
  initialState: generateStateSingle(SLICE_NAME),
  name: SLICE_NAME,
  extraReducers: {
    ...fetchData.generateExtraReducers(fetchUsers, SLICE_NAME),
    ...fetchEditData.generateExtraReducers(fetchUser, SLICE_NAME),
    ...createWithFile.generateExtraReducers(createUser, SLICE_NAME),
    ...deleteData.generateExtraReducers(deleteUser, SLICE_NAME),
    ...editData.generateExtraReducers(editUser, SLICE_NAME),
  },
});

export const getUsers = (state) => state.users;

export default userSlice.reducer;
